/** Query keys, in one place so hooks name the same thing everywhere. */
export const keys = {
  session: ['auth', 'session'] as const,
  profile: ['profile'] as const,
  sessions: ['profile', 'sessions'] as const,
  status: ['status'] as const,
  members: ['members'] as const,
  member: (id: string) => ['members', id] as const,
  activity: ['activity'] as const,
  clients: ['clients'] as const,
  client: (id: string) => ['clients', id] as const,
  jobTypes: ['job-types'] as const,
  jobTypesAll: ['job-types', 'all'] as const,
  levels: ['levels'] as const,
  workflows: (clientId: string) => ['workflows', clientId] as const,
  jobs: ['jobs'] as const,
  studioHours: (month: string) => ['jobs', 'hours-by-day', month] as const,
  paymentSheets: ['payment-sheets'] as const,
  paymentSheet: (id: string) => ['payment-sheets', id] as const,
  statements: ['statements'] as const,
  job: (id: string) => ['jobs', id] as const,
  assignments: (jobId: string) => ['jobs', jobId, 'assignments'] as const,
  notes: (entityType: string, entityId: string) => ['notes', entityType, entityId] as const,
  payments: (subject: string, id: string) => ['payments', subject, id] as const,
  myWork: ['portal', 'work'] as const,
  portalNotes: ['portal', 'notes'] as const,
  memberWork: (id: string) => ['members', id, 'work'] as const,
  paymentTotals: (subject: string, id: string) => ['payments', 'totals', subject, id] as const,
  apiTokens: ['api-tokens'] as const,
  runtimes: ['runtimes'] as const,
  jobDispatch: (jobId: string) => ['jobs', jobId, 'dispatch'] as const,
  notifications: ['notifications'] as const,
  announcements: ['announcements'] as const,
  allAnnouncements: ['announcements', 'all'] as const,
}
